import styled from '@emotion/styled';
import {
  ProjectOwnershipWrapper,
  TheaterTypeIndexMapper,
} from '@liveoptics/project.ownership.react-ui';
import React from 'react';
import { createRoot } from 'react-dom/client';

export const renderProjectOwnershipWrapper = (element: HTMLElement): void => {
  const Container = styled.div`
    line-height: normal;
    > div {
      margin-bottom: 0px !important;
      p {
        color: #ffffff !important;
      }
    }
  `;
  const projectIdValue = element?.getAttribute('project-id');
  const defaultTheaterValue = element?.getAttribute('default-theater');
  const userRoleValue = element?.getAttribute('user-role');
  const ownershipVerifiedValue = element?.getAttribute('ownership-verified');
  const ownerIdValue = element?.getAttribute('owner-id');
  const projectStatusValue = element?.getAttribute('project-status');
  if (
    element &&
    projectIdValue &&
    defaultTheaterValue &&
    userRoleValue &&
    ownershipVerifiedValue &&
    ownerIdValue != null &&
    projectStatusValue
  ) {
    if (element.className !== 'project-ownership-wrapper') {
      element.className = 'project-ownership-wrapper';
      const root = createRoot(element);
      root.render(
        <React.StrictMode>
          <Container>
            <ProjectOwnershipWrapper
              projectId={parseInt(projectIdValue)}
              defaultTheater={TheaterTypeIndexMapper[parseInt(defaultTheaterValue)]}
              userRole={userRoleValue}
              ownershipVerified={JSON.parse(ownershipVerifiedValue.toLowerCase())}
              ownerId={Number(ownerIdValue)}
              projectStatus={projectStatusValue}
              onSuccess={() => window.location.reload()}
            />
          </Container>
        </React.StrictMode>
      );
    }
  }
};
